<template>
  <div>
    <ManualOprationInfosRequester
      ref="manualOprationInfosRequester"
      @manualInfoFilled="onManualInfoFilled"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ManualOprationInfosRequester from './ManualOprationInfosRequester.vue'

export default defineComponent({
  name: 'TransactionLaunchedListener',
  components: { ManualOprationInfosRequester },
  props: {},
  data() {
    return {
      eventsIds: [],
      latestTransactionRequest: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'launch_transaction_request',
      this.saveTarnsactionRequest,
    )
    const id2 = this.$Events.handleEvent(
      'transaction_launched',
      this.onTransactionLaunched,
      'transaction_launched_listener',
    )
    const id3 = this.$Events.handleEvent(
      'failed_to_launch_transaction',
      this.onFailedToLaunchTransaction,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
    this.eventsIds.push(id3)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    saveTarnsactionRequest(data) {
      this.latestTransactionRequest = data
    },
    notifyTransactionLaunched() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Transaction initiée',
        body: 'Vous serez notifié après traitement',
      })
      this.$emit('transactionLaunched')
    },
    notifyTransactionNotLaunched(response) {
      console.log(response)
      const reason = response?.reason || 'unknown'
      this.$Events.dispatchEvent('toast_notification', {
        title: this.$t('messages.launchTransaction.title.' + reason),
        body: this.$t('messages.launchTransaction.details.' + reason),
      })
      if (reason == 'require_manual_operation_info')
        this.requestManualOperationInfos(response.error.data)
    },
    async requestManualOperationInfos(data) {
      this.$Events.dispatchEvent('finish_loading')
      await new Promise(r => setTimeout(r, 500))
      this.$refs.manualOprationInfosRequester.getManualOperationData(data, this.latestTransactionRequest)
    },
    onTransactionLaunched() {
      clearTimeout(this.autoClosingBottomsheetTimeoutId)
      this.notifyTransactionLaunched()
      setTimeout(() => {
        this.$Events.dispatchEvent('finish_loading')
      }, 1000)
    },
    onFailedToLaunchTransaction(response) {
      clearTimeout(this.autoClosingBottomsheetTimeoutId)
      setTimeout(() => {
        this.$Events.dispatchEvent('finish_loading')
      }, 1000)
      this.notifyTransactionNotLaunched(response)
    },
    onManualInfoFilled({manualCollectInfos, transactionData}) {
      const newTransactionData = {
        ...transactionData,
        manualInfoAdded: true,
        manualCollectInfos,
      }
      this.$Events.dispatchEvent(
        'launch_transaction_request',
        newTransactionData,
      )
    },
  },
})
</script>
